import Service from './service'
import locations from '../../locations/list'

export default {
  install: (app, i18n) => {
    app.config.globalProperties.$l10n = new Service({ i18n, locations })
  }
}
